import * as React from "react";

import Multimedia from "@stadium/shared/src/components/shared/multimedia";
import type { LinkRouteDefaults } from "@stadium/shared/src/components/link-with-lang";
import { LinkWithLang } from "components/plasmic/shared/link-with-lang/client";

import { CATALOG_ENTRIES_DEFAULTS, CE_13 } from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  FILTER_OPTIONS_VALUES,
  FilterOptionValue,
  LinkWithLangType,
} from "@stadium/shared/src/constants/stores/routes";

import styles from "./main.module.scss";

export interface CatalogItem {
  image?: string;
  imageAlt?: string;
  catalogTitle?: string;
  categoryLinkType?: LinkWithLangType;
  filterOptions?: FilterOptionValue;
  linkOpenInNewTab?: boolean;
  linkOtherUrl?: string;
  categorySlug?: string;
}

export interface CE13Props {
  heading?: string;
  catalogs?: CatalogItem[];
  className?: string;
  linkRouteDefaults?: LinkRouteDefaults;
}

const ce13Defaults = CATALOG_ENTRIES_DEFAULTS[CE_13];

const DEFAULT_OBJ = {};

const CE13 = ({
  heading = ce13Defaults.heading,
  catalogs = ce13Defaults.catalogs,
  className = "",
  linkRouteDefaults,
}: CE13Props) => {
  return (
    <section className={`${styles.sectionWrapper} ${className}`}>
      <div className={styles.container}>
        {heading && <h2 className={styles.heading}>{heading}</h2>}
        <div className={styles.catalogGrid}>
          {catalogs
            .filter((item) => item.image && item.catalogTitle)
            .map((item, index) => {
              const itemContent = (
                <>
                  <div className={styles.imageWrapper}>
                    {item.image && (
                      <Multimedia
                        type="image"
                        src={item.image?.url || item.image}
                        alt={item.imageAlt || item.catalogTitle}
                        className={styles.cardImage}
                      />
                    )}
                  </div>
                  {item.catalogTitle && <h3 className={styles.cardTitle}>{item.catalogTitle}</h3>}
                </>
              );

              if (!item.categoryLinkType) {
                return (
                  <div
                    key={`${item.catalogTitle ?? "catalog"}-${index}`}
                    className={styles.catalogCard}
                  >
                    {itemContent}
                  </div>
                );
              }
              const query = item.filterOptions
                ? FILTER_OPTIONS_VALUES[item.filterOptions]
                : DEFAULT_OBJ;
              return (
                <LinkWithLang
                  key={`${item.catalogTitle ?? "catalog"}-${index}`}
                  {...linkRouteDefaults}
                  type={item.categoryLinkType}
                  data={{ code: item.categorySlug, url: item.linkOtherUrl }}
                  target={item.linkOpenInNewTab ? "_blank" : "_self"}
                  className={styles.catalogCard}
                  query={query}
                >
                  {itemContent}
                </LinkWithLang>
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default CE13;
